import React, { useState } from "react";
import { Modal } from "antd";
import useAxios from "../../../hooks/useAxios";

function AddDocumentName({
  setDocumentName,
  documentName,
  setOpenDocumentname,
  openDocumentname,
  setLoad,
  getAllFormNames,
}) {
  const api = useAxios();

  const handleSubmit = async (e) => {
    setLoad(true);
    try {
      const result = await api.post(
        `/companyDocumentNames`,
        {
          documentName,
          status: true,
        },
        { tokenType: "user" }
      );
      getAllFormNames()
      setLoad(false);
      setDocumentName("");
      console.log(result);
      setOpenDocumentname(false);
    } catch (err) {
      console.log(err);
      setLoad(false);
      setOpenDocumentname(false);
    }
  };

  return (
    <Modal
      centered
      open={openDocumentname}
      onOk={() => setOpenDocumentname(false)}
      onCancel={() => setOpenDocumentname(false)}
      width={500}
      zIndex={2}
      footer={<></>}
      title="Compnay Document"
    >
      <div className="row">
        <div className="form-group col-md-12 form-builder-element mb-3">
          <label htmlFor="">
            Enter Document Name
            <span style={{ color: "red" }}>*</span>
          </label>
          <input
            className="form-control form-view"
            type="text"
            placeholder=""
            name="name"
            onChange={(e) => setDocumentName(e.target.value)}
            value={documentName}
          />
        </div>
        <div className="col-4 d-flex align-items-center">
          <button
            className={`btn ${
              !documentName.trim() ? "btn-secondary" : "btn-primary"
            } mt-1`}
            onClick={handleSubmit}
            disabled={!documentName.trim()}
          >
            Submit
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default AddDocumentName;
